import {
  // GET BANKING LIST
  GET_BANKING_LIST,
  GET_BANKING_LIST_SUCCESS,
  GET_BANKING_LIST_FAILED,

  // Add BANKING OF PLACE
  ADD_BANKING_OF_PLACE,
  ADD_BANKING_OF_PLACE_SUCCESS,
  ADD_BANKING_OF_PLACE_FAILED,

  // UPDATE BANKING OF PLACE
  UPDATE_BANKING_OF_PLACE,
  UPDATE_BANKING_OF_PLACE_SUCCESS,
  UPDATE_BANKING_OF_PLACE_FAILED,

  // REQUEST UPDATE BANKING OF PLACE
  REQUEST_UPDATE_BANKING_OF_PLACE,
  REQUEST_UPDATE_BANKING_OF_PLACE_SUCCESS,
  REQUEST_UPDATE_BANKING_OF_PLACE_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetBankingList: false,
  isLoadingUpdateBankingOfPlace: false,

  bankingList: [],
};

export default function banking(state = initialState, action) {
  switch (action.type) {
    case GET_BANKING_LIST:
      return {
        ...state,
        isLoadingGetBankingList: true,
      };

    case GET_BANKING_LIST_SUCCESS:
      return {
        ...state,
        isLoadingGetBankingList: false,
        bankingList: action.payload.data,
      };

    case GET_BANKING_LIST_FAILED:
      return {
        ...state,
        isLoadingGetBankingList: false,
      };

    // ADD BANKING OF PLACE
    case ADD_BANKING_OF_PLACE:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: true,
      };

    case ADD_BANKING_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: false,
      };

    case ADD_BANKING_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: false,
      };

    // UPDATE BANKING OF PLACE
    case UPDATE_BANKING_OF_PLACE:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: true,
      };

    case UPDATE_BANKING_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: false,
      };

    case UPDATE_BANKING_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: false,
      };

    // REQUEST UPDATE BANKING OF PLACE
    case REQUEST_UPDATE_BANKING_OF_PLACE:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: true,
      };

    case REQUEST_UPDATE_BANKING_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: false,
      };

    case REQUEST_UPDATE_BANKING_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingUpdateBankingOfPlace: false,
      };

    default:
      return state;
  }
}
